import {
  defineStore,
} from "pinia";
import {
  useApiFetch,
} from "~/composables/useApiFetch";

interface PersonalCreditsProfile {
  personalCredits?: number;
}

export const usePersonalCreditsStore = defineStore("personalCredits", {
  state: () => ({
    balance: 0,
    loading: false,
    userSub: null as string | null,
  }),

  actions: {
    async load(userSub: string, force = false): Promise<void> {
      if (!force && this.userSub === userSub) {
        return;
      }
      if (this.userSub !== userSub) {
        this.balance = 0;
      }
      this.userSub = userSub;
      this.loading = true;
      try {
        const apiFetch = useApiFetch();
        const profile = await apiFetch<PersonalCreditsProfile>("/users/profile");
        if (this.userSub === userSub) {
          this.balance = profile?.personalCredits ?? 0;
        }
      } catch {
        if (this.userSub !== userSub) {
          return;
        }
      } finally {
        if (this.userSub === userSub) {
          this.loading = false;
        }
      }
    },

    async refresh(): Promise<void> {
      if (this.userSub) {
        await this.load(this.userSub, true);
      }
    },

    clear(): void {
      this.userSub = null;
      this.balance = 0;
      this.loading = false;
    },
  },
});
